import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=050a7c7b"
import script from "./Snackbar.vue?vue&type=script&lang=ts"
export * from "./Snackbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports